module.exports = __webpack_public_path__ + "static/media/undp-logo3.0c5e3e05.png";